import MaterialTable from 'material-table';
import React from 'react';
import { defaultGridOptions, parseCLDR26, useGridColDefs } from '../../utils/GridUtils';

const ExchangeDifferenceGrid = ({ data, tableRef }) => {
  const colDefs = useGridColDefs([
    { title: 'Nro. Factura', field: 'fiscalDoc' },
    { title: 'Moneda', field: 'currency', align: 'center', hidden: true },
    { title: 'Importe en Moneda Extranjera', field: 'docImport', currencyRef: 'currency' },
    { title: 'Tipo Cambio BNA de la factura', field: 'exchangeTypeInvoice', valueType: 'numeric' },
    { title: 'Diferencia 5%', field: 'exchangeDifInvoicePay', valueType: 'numeric' },
    { title: 'Fecha Orden de pago', field: 'recordDate', valueType: 'date' },
    { title: 'Fecha Pago efectivo', field: 'payDate', valueType: 'date' },
    { title: 'Tipo cambio pagado', field: 'exchangeTypePaid', valueType: 'numeric' },
    { title: 'Tipo cambio BNA', field: 'exchangeTypeRecord', valueType: 'numeric' },
    {
      title: 'Dif. Cambio a facturar',
      field: 'exchangeDifInvoice',
      valueType: 'numeric',
      valueRender: (value, rowData) => `ARS ${parseCLDR26(value)}`,
    },
  ]);

  return (
    <MaterialTable
      {...defaultGridOptions}
      columns={colDefs}
      data={data}
      tableRef={tableRef}
      options={{
        ...defaultGridOptions.options,
        pageSize: tableRef?.current?.dataManager?.pageSize || defaultGridOptions.options.pageSize,
      }}
    />
  );
};

export default ExchangeDifferenceGrid;
